// @flow

import * as React from 'react'
import styled from 'styled-components'
import {
  ControlLabel,
  EditorInput,
  FilesInput,
  FilesExistingValue,
  FormInput,
  FormGroup,
  RadioInput,
  SelectInput,
  unwrapTemporaryFile,
} from '../../../../../infrastructure/components/Formik'
import { SettingsSeparator, SpacingSettings } from '../shared'

const WebshopHeaderBackdropSettings = ({ values }) => {
  const [replaceStaticBackdrop, setReplaceStaticBackdrop] =
    React.useState(false)

  const { unwrappedBackdropValue } = React.useMemo(() => {
    let unwrappedBackdropValue = null

    if (values.data.backdrop) {
      unwrappedBackdropValue = unwrapTemporaryFile(values.data.backdrop)
    }

    return {
      unwrappedBackdropValue,
    }
  }, [values.data.backdrop])

  return (
    <div>
      <FormGroup>
        <ControlLabel required>Backdrop image or video</ControlLabel>
        {(replaceStaticBackdrop || !unwrappedBackdropValue) && (
          <FilesInput allowMultiple={false} name="data.backdrop" />
        )}
        <FilesExistingValue
          onChange={() => setReplaceStaticBackdrop(true)}
          shouldChange={replaceStaticBackdrop}
          value={unwrappedBackdropValue}
        />
      </FormGroup>
      <FormGroup>
        <ControlLabel required>Backdrop height</ControlLabel>
        <HeightInputsContainer>
          <HeightModeSelectContainer>
            <SelectInput
              name="data.height_mode"
              options={heightModeOptions}
              simpleValue
              clearable={false}
            />
          </HeightModeSelectContainer>
          {values.data.height_mode === 'viewport_percentage' && (
            <>
              <HeightValueInputContainer>
                <FormInput
                  name="data.viewport_percentage_height"
                  type="number"
                  max={100}
                  min={1}
                />
              </HeightValueInputContainer>
              <div>%</div>
            </>
          )}
          {values.data.height_mode === 'fixed' && (
            <>
              <HeightValueInputContainer>
                <FormInput name="data.fixed_height" type="number" />
              </HeightValueInputContainer>
              <div>px</div>
            </>
          )}
        </HeightInputsContainer>
      </FormGroup>

      <FormGroup>
        <ControlLabel required>Position of widgets inside</ControlLabel>
        <RadioInput
          id="inner_elements_position_bottom_left"
          name="data.inner_elements_position"
          label="Bottom left corner"
          value="bottom_left"
        />
        <RadioInput
          id="inner_elements_position_bottom_center"
          name="data.inner_elements_position"
          label="Bottom center"
          value="bottom_center"
        />
        <RadioInput
          id="inner_elements_position_bottom_right"
          name="data.inner_elements_position"
          label="Bottom right corner"
          value="bottom_right"
        />
      </FormGroup>

      <SettingsSeparator />

      <SpacingSettings enabledSpacingKeys={enabledSpacingKeys} />
    </div>
  )
}

export default WebshopHeaderBackdropSettings

const heightModeOptions = [
  { label: 'Screen percentage', value: 'viewport_percentage' },

  // TODO: option not implemented yet
  // { label: 'Keep image aspect ratio', value: 'keep_image_aspect_ratio' },

  { label: 'Fixed', value: 'fixed' },
]

const HeightInputsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const HeightModeSelectContainer = styled.div`
  flex: 0 0 170px;
  margin-right: 6px;
`

const HeightValueInputContainer = styled.div`
  flex: 0 0 70px;
  margin-right: 6px;
`

const enabledSpacingKeys = ['paddingLeft', 'paddingRight', 'paddingBottom']
